<nav class="navbar navbar-default navbar-fixed-top top-bar-region top-bar primary tw-py-spacing-0 tw-px-spacing-200">
  <div class="tw-flex tw-items-center tw-flex-start tw-w-full">
    @if (backLink() !== undefined) {
      <a class="top-bar-link" [routerLink]="backLink()">
        <app-icon name="chevron-left" size="sm" class="tw-text-white tw-align-middle" />
      </a>
    }
    <p class="navbar-text tw-text-center md:tw-text-left tw-flex-1">{{ title() || settings.name }}</p>
  </div>
</nav>
